import { createAsyncThunk } from '@reduxjs/toolkit';
import { ILessonHistory } from '.';
import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { AdminApiPaths } from '../../../api/APIPaths';

export type TAdminLessonHistoryListGet = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
  studentId?: string;
  tutorId?: string;
  courseId?: string;
};

export type TAdminGetLessonHistoryById = {
  id: string;
};

const apiDataProvider = new APIDataProvider();

export const adminLessonHistoryListGet = createAsyncThunk(
  '/admin/lesson-history/list',
  async ({
    limit,
    offset,
    sortKey,
    sortValue,
    startDate,
    endDate,
    studentId,
    tutorId,
    courseId,
  }: TAdminLessonHistoryListGet) => {
    let path = `${AdminApiPaths.lessonHistory}?limit=${limit}&offset=${offset}`;

    if (sortKey) {
      path += `&sortKey=${sortKey}`;
    }

    if (sortValue) {
      path += `&sortValue=${sortValue}`;
    }

    if (startDate) {
      path += `&startDate=${startDate}`;
    }

    if (endDate) {
      path += `&endDate=${endDate}`;
    }

    if (studentId) {
      path += `&studentId=${studentId}`;
    }

    if (tutorId) {
      path += `&tutorId=${tutorId}`;
    }

    if (courseId) {
      path += `&courseId=${courseId}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<ILessonHistory>>
    >(path);

    return response.data;
  }
);

export const adminGetLessonHistoryById = createAsyncThunk(
  '/admin/lesson-history/getOne',
  async ({ id }: TAdminGetLessonHistoryById) => {
    const path = `${AdminApiPaths.lessonHistory}/${id}`;

    const response = await apiDataProvider.get<TApiResponse<ILessonHistory>>(
      path
    );

    return response.data;
  }
);
